import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { LinhaPendenciaPonto } from './servico-pendencia-ponto';

@Component({
  selector: 'app-grade-pendencia-ponto',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './grade-pendencia-ponto.component.html'
})
export class GradePendenciaPontoComponent {
  @Input() linhas: LinhaPendenciaPonto[] = [];
  @Input() pesquisado = false;
}
